import React, { Component, Fragment } from 'react';
import ChangePhoneForm from './changePhoneComponents/ChangePhoneForm';
import PhoneSmsVerificationCode from './changePhoneComponents/PhoneSmsVerificationCode';

class ProfileChangePhoneNumber extends Component {
  state = {
    showPhoneForm: true,
    phone: '',
    phoneCountry: { value: 'norway', label: '+47' },
  }

  changePhoneCountry = (phoneCountry) => {
    this.setState({ phoneCountry: phoneCountry });
  }

  changePhoneNumber = (value) => {
    this.setState({ phone: value });
  }

  toggleView = () => {
    this.setState({ showPhoneForm: !this.state.showPhoneForm })
  }

  render() {
    if (this.state.showPhoneForm) {
      return (
        <ChangePhoneForm
          changePhoneCountry={this.changePhoneCountry}
          changePhoneNumber={this.changePhoneNumber}
          phone={this.state.phone}
          phoneCountry={this.state.phoneCountry}
          toggleView={this.toggleView}
          locale={this.props.locale}
        />
      );
    } else {
      return (
        <PhoneSmsVerificationCode
          changePhoneCountry={this.changePhoneCountry}
          changePhoneNumber={this.changePhoneNumber}
          phone={this.state.phone}
          phoneCountry={this.state.phoneCountry}
          toggleView={this.toggleView}
        />
      );
    }
  }
}

export default ProfileChangePhoneNumber;